class NavigableDropdown extends HTMLElement {
  constructor() {
    super();

    this.dropdown = this.querySelector('select');

    if (this.dropdown) {
      this.dropdown.addEventListener('change', (event) => {
        window.location.href = this.dropdown.value;
      });
    }
  }
}

customElements.define('navigable-dropdown', NavigableDropdown);
